import { memo, useEffect } from 'react';

import { logDebug } from '../../lib/logger';
import { useUnreadCounts } from '../../lib/unread_store';
import { useUnreadActivityCount } from '../../lib/useUnreadActivityCount';

import { useWindowReadingFocus } from '../../hooks/useWindowReadingFocus';

const UnreadReporter = memo(function UnreadReporter({ channelIds, activeChannelId }) {
  const unreadCounts = useUnreadCounts(channelIds);
  const activityCount = useUnreadActivityCount();
  const windowReadingFocus = useWindowReadingFocus();

  useEffect(() => {
    if (!unreadCounts?.counts) return;

    const omitActiveFromAggregates = windowReadingFocus;

    const data = [];
    Object.entries(unreadCounts.counts).forEach(([channelId, counts]) => {
      // compare as strings: Object.entries yields string keys, activeChannelId may be number from Dexie
      const isActive = String(channelId) === String(activeChannelId);
      if (!isActive || !omitActiveFromAggregates) {
        data.push({ channelId, messages: counts.messages, mentions: counts.mentions });
      }
    });

    const totalMessages = data.reduce((sum, c) => sum + c.messages, 0);
    const totalMentions = data.reduce((sum, c) => sum + c.mentions, 0);

    logDebug('UnreadReporter', 'output:unread-counts', { totalMessages, totalMentions, activityCount, channelCount: data.length, data });

    window.dispatchEvent(new CustomEvent('output:unread-counts', { detail: { unreadCounts: data, activityCount } }));
  }, [activityCount, unreadCounts?.counts, activeChannelId, windowReadingFocus]);

  return null;
});

export default UnreadReporter;
